"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RcrtUser = exports.RcrtUserTypeMap = exports.ERcrtClubUserRole = exports.ERcrtUserType = void 0;
const model_core_1 = require("@nxt/model-core");
const index_1 = require("../index");
var ERcrtUserType;
(function (ERcrtUserType) {
    ERcrtUserType["NONE"] = "";
    ERcrtUserType["PLAYER"] = "p";
    ERcrtUserType["PLAYER_COACH"] = "pc";
    ERcrtUserType["COLLEGE_COACH"] = "cc";
    ERcrtUserType["PARENT"] = "pp";
    ERcrtUserType["ADVISOR"] = "a";
})(ERcrtUserType || (exports.ERcrtUserType = ERcrtUserType = {}));
var ERcrtClubUserRole;
(function (ERcrtClubUserRole) {
    ERcrtClubUserRole["NONE"] = "";
    ERcrtClubUserRole["READ_ONLY"] = "r";
    ERcrtClubUserRole["READ_WRITE"] = "rw";
})(ERcrtClubUserRole || (exports.ERcrtClubUserRole = ERcrtClubUserRole = {}));
exports.RcrtUserTypeMap = {
    p: 'Player',
    pc: 'HS/Club Coach/Admin',
    cc: 'College Coach',
    pp: 'Parent',
    a: 'Advisor'
};
;
class RcrtUser extends model_core_1.User {
    image = null;
    type = ERcrtUserType.NONE;
    bio = {};
    address = null;
    teams = [];
    links = {};
    collab = '';
    club = '';
    rating_factors = [];
    event_refs = new model_core_1.ChildArray();
    college_refs = new model_core_1.ChildArray();
    collabs = new model_core_1.ChildArray();
    shares = new model_core_1.ChildArray();
    orders = new model_core_1.ChildArray();
    last_check = 0;
    counts = { colleges: 0, archived: 0, events: 0, collabs: 0, emails: 0, shares: 0, todos: 0 };
    results_views = 0;
    results_card = 0;
    results_pviews = 0;
    results_plays = 0;
    get sports() {
        return this.teams.reduce((sports, team) => {
            if (!sports.find(i => i.gender === team.gender && i.sport === team.sport)) {
                sports.push(team);
            }
            return sports;
        }, []);
    }
    get canSync() {
        if (this.email?.match(/gmail\.com$/)) {
            return true;
        }
        else {
            return false;
        }
    }
    get isSynced() {
        return (this.metadata.email) ? true : false;
    }
    _m = ['name', 'email', 'first_name', 'last_name'];
    _s = ['name', 'email', 'first_name', 'last_name', 'teams'];
    _d = ['addresses', 'cards', 'devices', 'location', 'location_id', 'nick_name', 'online', 'photoURL', 'role', 'signature', 'tax', 'unread'];
    constructor(data, olMap, type, idLen) {
        super(data, olMap || index_1.olm);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, RcrtUser);
    }
    async loadAll(opts, stack, p) {
        opts = opts || {};
        opts.olm = opts.olm || index_1.olm;
        await super.loadAll(opts, stack, p);
    }
    toJSON() {
        let r = super.toJSON();
        ['x', 'instagram'].forEach(p => {
            if (this.links[p]) {
                let parts = this.links[p].split('/');
                if (parts.length) {
                    this.links[p] = parts[parts.length - 1];
                }
                this.links[p] = this.links[p].replace('@', '');
            }
        });
        if (this.teams?.length) {
            r.teams = this.teams?.map(t => {
                return t;
            });
        }
        return r;
    }
    toPublicJSON() {
        let r = this.toJSON();
        ['college_refs', 'event_refs'].forEach(p => {
            delete r[p];
        });
        return r;
    }
}
exports.RcrtUser = RcrtUser;
index_1.olm.users = (ref, map) => {
    return new RcrtUser(ref, map);
};
